export type EssentialTool = {
  id: string
  label: string
  title: string
  subtitle: string
  paragraphs: string[]
  benefit: string
}

export const essentialTools: EssentialTool[] = [
  {
    id: '1',
    label: 'Essential Tool 1',
    title: 'BJJ Coaching Cues, Corrections & Common Mistakes',
    subtitle:
      'Clear teaching language, effective corrections and practical solutions for the most common errors on the mat',
    paragraphs: [
      'A complete guide to identifying frequent technical errors and correcting them using clear, simple and effective coaching language. Covers base position, guard, escapes, passing, positional control, transitions, takedowns and submissions. For each area, you receive practical cues you can use during class without overwhelming your student with unnecessary technical detail.',
      'The guide also helps you understand the possible causes behind each error and choose the right correction, drill or progression. Especially useful when a student feels stuck, repeats the same mistake or struggles to understand traditional technical explanations.',
    ],
    benefit: 'No preparation needed. Open it, read it, teach it.',
  },
  {
    id: '2',
    label: 'Essential Tool 2',
    title: '200 BJJ Drills, Training Games & Skill Challenges',
    subtitle:
      'A complete activity bank for more dynamic, varied and engaging BJJ classes',
    paragraphs: [
      '200 practical drills, games and challenges that make BJJ classes more engaging, structured and goal-oriented. Covers movement, timing, coordination, control, reaction speed, positional awareness, guard retention, escapes, passing, takedowns and submissions. Can be used in private lessons, small groups, youth programs, adult clinics and academy sessions.',
      'Each activity focuses on a specific skill while keeping students active and motivated. Use them as the main part of a session, as a progress challenge, as a review activity or as a competitive game between students.',
    ],
    benefit: '200 new ideas ready to use. The variety is already built in.',
  },
]
